/**
 * @fileoverview Timesheet Settings — firm configuration (MOR-906)
 *
 * URL: /dashboard/timesheet-settings
 * Protection: authenticated. Writes require org admin/owner (`canEdit` +
 * server-side checks).
 *
 * Billing increment, time categories (with IPS analysis-code mapping),
 * staff grades with effective-dated rate cards, and per-member grade /
 * staff-code assignment.
 *
 * Dependencies:
 * - Convex: timesheets.settings.*, timesheets.categories.*,
 *   timesheets.grades.*, timesheets.profiles.*
 */

import { createFileRoute } from "@tanstack/react-router";

import type { Id } from "@cvx/_generated/dataModel";

import { useActiveOrg } from "@/utils/org-context";
import { TimesheetSettingsManager } from "@/components/timesheets/TimesheetSettingsManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/timesheet-settings",
)({
  beforeLoad: () => ({ headerTitle: "Timesheet Settings" }),
  component: TimesheetSettingsPage,
});

function TimesheetSettingsPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <TimesheetSettingsManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage timesheet settings.
        </div>
      )}
    </div>
  );
}
